export const UNASSIGNED_APARTMENT_GROUP_ID = '__UNASSIGNED__';
